module.exports = __webpack_public_path__ + "img/zhizhen.221aafe0.svg";